import { api } from 'api';

const getCurrencyRate = async ({ from, to }) => {
  const { data } = await api.get(`currency/${from}/${to}`);
  return data;
};

export default getCurrencyRate;
